module.exports = __webpack_public_path__ + "ins12.png?e7ffcbebea4c5b1c23c3d9434d16dfcf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins12.png
// module id = 163
// module chunks = 0